import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {makeSizeConstants} from '../../../../../../libs/shared/ui/src/styles/styleHelpers';
import {CellsEmptySetupActionsDefinition} from './cellsEmptyCommon';

const marginSizes = makeSizeConstants(9, 14);

/*
 * Style.
 */

interface StyleProps {
  $marginSize: VisualSizesEnum;
}

const StyledDiv = styled.div<StyleProps>`
  margin-top: ${(p) => marginSizes[p.$marginSize]}px;
  display: flex;
  justify-content: center;
`;

/*
 * Component.
 */

export const CellsEmptySetupActionsLink: FC<CellsEmptySetupActionsDefinition> = ({
  title,
  onClick,
  interactionId,
  spacingSize,
}) => (
  <StyledDiv $marginSize={spacingSize ?? VisualSizesEnum.MEDIUM}>
    <Button
      interactionId={interactionId}
      onClick={onClick}
      variant={ButtonVariantsEnum.LINK}
      size={VisualSizesEnum.MEDIUM}
    >
      {title}
    </Button>
  </StyledDiv>
);
